import { Environment } from './environment-interface';

export const environment: Environment = {
	name: 'test',
	enableLogging: true,
	cognito: {
		userPoolId: 'eu-west-1_vdC78GvJz',
		userPoolClientId: '2gmd5vnusgbu84jsrq06mc03q9',
		identityPoolId: 'eu-west-1:840eb556-4200-4432-95e6-71b2ba8868f5',
	},
	api: 'https://6ygoz5a0j7.execute-api.eu-west-1.amazonaws.com/test'
};
